import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-clock-icon',
  templateUrl: './clock.component.html'
})
export class ClockComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
